module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head_fm"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "chap"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/chaptermark2.png"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Dedication#bded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("DEDICATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "epig"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Epigraph#bepig",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("EPIGRAPH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "ill"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Illustrations#bill"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("LIST OF ILLUSTRATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bs",
    attrs: {
      "id": "note"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Anote#bnote"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("A NOTE TO THE READER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Prologue#bpro"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch01"
    }
  }, [_vm._v("  1."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter01#bch01"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“Such Dangerous Toys”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("  2."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('a', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter02#bch02"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“The Glow from That Fire”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("  3."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter03#bch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“Show These Texans What Good Taste Really Is”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch04"
    }
  }, [_vm._v("  4."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter04#bch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“A Bright Pink Suit”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch05"
    }
  }, [_vm._v("  5."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter05#bch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“Someone Is Shooting at the President”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch06"
    }
  }, [_vm._v("  6."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter06#bch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“They’ve Shot His Head Off”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch07"
    }
  }, [_vm._v("  7."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter07#bch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“I Haven’t Shot Anybody”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch08"
    }
  }, [_vm._v("  8."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter08#bch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“We Had a Hero for a Friend”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch09"
    }
  }, [_vm._v("  9."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter09#bch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“Lee Oswald Has Been Shot!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "ch10"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "spacer_toc"
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Chapter10#bch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("“One Brief Shining Moment”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_chap",
    attrs: {
      "id": "epi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Epilogue: “All His Bright Light Gone from the World”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ts",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Acknowledgments#back",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Bibliography#bbib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "source"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Source#bsource",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SOURCE NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "idx"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Index#bidx",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "auth"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Author#bauth",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "alsoby"
    }
  }, [_c('a', {
    attrs: {
      "id": "ztocz"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Alsoby#zhead1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Books by James L. Swanson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "credits"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Credits#bcredits",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "copy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Copyright#bcopy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("COPYRIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "pub"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9780062300201_Publisher#bpub",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ec0373a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9780062300201_Contents.vue
// module id = 69
// module chunks = 0